"use client";
import React from "react";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import styles from "./Header.module.css";

const Header = () => {
  return (
    <>
      <DesktopHeader className={styles.desktopOnly} theme="light" />
      <MobileHeader className={styles.mobileOnly} theme="light" />
    </>
  );
};

export default Header;
